import styled, { css } from 'styled-components';
import { gray, grayDark, grayDarker, blue } from '@bufferapp/ui/style/colors';
import { fontFamily } from '@bufferapp/ui/style/fonts';

export const Wrapper = styled.div<{ colored: boolean }>`
  display: flex;
  flex-direction: row;
  gap: 10px;
  padding: 10px 8px;
  font-family: ${fontFamily};
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;

  ${(props) =>
    props.colored &&
    css`
      background: linear-gradient(79.75deg, #f4ffe7 1.26%, #e0e5ff 100.73%),
        #ffffff;
      border-radius: 4px 4px 0px 0px;
    `}

  svg {
    fill: ${(props) => (props.colored ? blue : gray)};
  }

  p {
    color: ${(props) => (props.colored ? grayDarker : grayDark)};
    padding: 0;
    margin: 0;
    margin-bottom: 4px;
  }

  a {
    color: ${blue};
    text-decoration: none;
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
`;
